<div class="cq-footer">
  <div class="references">
    <a
      target="_blank"
      href="https://accounts.eu1.gigya.com/accounts.store.downloadPublicConsentDocument?docID=97041812_227172903830_e902260602ac421c88a5fe94ad95eb36.pdf"
      title="Conditions of Use"
      >Conditions of Use</a
    >
    <a target="_blank" href="https://www.covestro.com/en/legal/imprint" title="Imprint">Imprint</a>
    <a target="_blank" href="https://www.covestro.com/en/legal/privacy-statement" title="Privacy Statement"
      >Privacy Statement</a
    >
  </div>
  <div class="right">
    <a
      class="slogan-text"
      target="_blank"
      href="https://www.covestro.com/en/sustainability/what-drives-us/circular-economy/circular-intelligence"
      >CIRCULAR INTELLIGENCE</a
    >
    <div class="site-copyright">Copyright © 2025 Covestro AG</div>
  </div>
</div>
